<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <!-- 主体 -->
        <div :class="css.container" class="pt-[120px] mx-auto w-[1136px]" v-loading="loading">
            <div class="text-center font-bold text-emphas text-[40px] leading-[72px]">{{ $t("SequenceProcessor") }}</div>

            <!-- 输入界面 -->
            <div class="text-center px-[64px] leading-[22px]">
                {{ $t("SequenceProcessorDescript") }}
            </div>
            <div class="mt-[24px] text-right hidden">
                <span class="transition duration-200 cursor-pointer underline underline-offset-4 hover:text-main">
                    {{ $t("ClickViewTutorial") }}
                </span>
            </div>
            <div class="mt-[16px] bg-color7 px-[48px] pt-[24px] pb-[40px] flex">
                <div class="mr-[16px]">
                    <div class="mb-[8px] last:mb-0 font-bold text-emphas">{{ $t("TaskType") }}:</div>
                    <div v-for="value in options.tasks">
                        <div
                            :class="[css.type, value.value == excute.value && css.active]"
                            class="w-[202px] py-[8px] px-[20px] border border-solid border-uicolor4 rounded-[4px] bg-white mb-[12px] cursor-pointer"
                            @click="methods.switch(value)">
                            {{ value.label }}
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="mb-[8px] font-bold text-emphas">{{ $t("InputBox") }}</div>
                    <ui-textarea
                        v-model="sequence"
                        class="h-[280px]"
                        :class="css.textarea"
                        placeholder="Please enter a DNA or RNA sequence."
                        v-on="ons.textarea">
                    </ui-textarea>
                    <div class="mt-[16px]" v-show="has_ambiguity_codes">{{ $t("SequencesContainingAmbiguityCodes") }}</div>
                    <div class="flex mt-[24px]">
                        <ui-button :width="112" size="middle" :disabled="!sequence.length" @click="methods.submit">{{ $t("Submit") }}</ui-button>
                        <ui-button :width="112" size="middle" class="ml-[16px]" :class="css_button.cancel" :disabled="!sequence.length">
                            {{ $t("Clear") }}
                        </ui-button>
                    </div>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiButton, UiTextarea } from "various-ui";

//* 组件属性
import { useComposable } from "./src/composable";

//* 样式
import css_button from "@/assets/style/src/button.module.less";
import css from "./index.module.less";

//* 组合函数
const { options, refs, methods, ons } = useComposable();
const { loading, excute, sequence, has_ambiguity_codes } = refs;
</script>
